var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSinPlanForzoso(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.28 36.073l-4.947 4.97-4.946-4.97-3.314 3.314 4.97 4.946-4.97 4.947 3.314 3.313 4.946-4.97 4.947 4.97 3.313-3.313-4.97-4.947 4.97-4.946M14 4.667a4.65 4.65 0 00-4.667 4.666v37.334A4.65 4.65 0 0014 51.333h18.223a13.94 13.94 0 01-1.89-7c0-.77.07-1.563.187-2.333H14v-4.667h18.223c1.074-1.866 2.567-3.5 4.364-4.666H14V28h28v2.52c.77-.117 1.563-.187 2.333-.187.794 0 1.564.07 2.334.187V18.667l-14-14m-2.334 3.5L43.167 21H30.333V8.167z",
    fill: "#54DCF2"
  })));
}
export default SvgIconSinPlanForzoso;